"use client";

import type { ReactNode } from "react";
import { useTranslations } from "use-intl";

import { NotificationIcon } from "@/components/appIcons";
import { useDealOfferPriceAlert } from "@/components/marketplace/deal-offer-price-alert-context";
import { Button } from "@/components/ui/button";

export function DealOfferStoreDisclosure() {
  const t = useTranslations("shared.affiliates");
  return (
    <p className="mt-2 px-1 text-xs leading-normal text-muted-foreground">
      {t("catalogOffersStoreDisclosure")}
    </p>
  );
}

export function DealOfferPanelFooter({ actions }: { actions?: ReactNode }) {
  const t = useTranslations("shared.affiliates");
  const onPriceAlert = useDealOfferPriceAlert();
  if (!actions && !onPriceAlert) return null;

  return (
    <div className="flex flex-col gap-1 border-t border-border px-4 py-2 sm:px-6">
      {(actions || onPriceAlert) && (
        <div className="flex flex-wrap items-center justify-between gap-x-4">
          {actions}
          {onPriceAlert && (
            <Button
              variant="link"
              className="ml-auto h-auto min-h-11 px-0 text-xs font-medium text-foreground hover:text-primary lg:min-h-8"
              onClick={onPriceAlert}
            >
              <NotificationIcon aria-hidden="true" />
              <span>{t("priceAlertCta")}</span>
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
